<template>
    <div :style="containerStyles">
        <ui-toolbar
                :brand="title"
                title=" "
                nav-icon="arrow_back"
                type="clear"
                :raised="false"
                text-color="white"
                @nav-icon-click="close"
        >
        <div slot="actions">
                <ui-icon-button
                    v-if="allowDownload"
                    color="white"
                    icon="file_download"
                    size="normal"
                    type="secondary"
                    @click.prevent="download"
                ></ui-icon-button>

                <ui-icon-button
                    v-if="allowEmail"
                    :loading="isPreparingEmail"
                    color="white"
                    icon="email"
                    size="normal"
                    type="secondary"
                    @click.prevent="email"
                ></ui-icon-button>

                <ui-icon-button
                    v-if="allowPrint"
                    color="white"
                    icon="print"
                    size="normal"
                    type="secondary"
                    @click.prevent="print"
                ></ui-icon-button>
        </div>
        </ui-toolbar>
        <div v-if="isOpen" style="position: absolute; top: 60px; left: 0; right: 0; bottom: 0;">
            <div v-if="isImage" style="width: 100%; height: 100%; overflow: auto;">
                <img ref="image" :src="baseUri" style="width: 100%; height: auto;" />
            </div>
            <iframe v-else ref="frame" style="width: 100%; height: 100%; border: none; background: transparent;" :src="baseUri"></iframe>
        </div>

        <compose-message-modal ref="compose"></compose-message-modal>
    </div>
</template>

<script>
    import Resource from '../classes/Api/Resource'
    import ComposeMessageModal from "./inbox/ComposeMessageModal";
    import {printElement} from "../utils";

    export default {
        components: { ComposeMessageModal },
        props: {
            title: {
                type: String,
                default() {
                    return 'Document';
                }
            },
            mime: {
                type: String
            },
            baseUri: {
                type: String,
            },
            allowPrint: {
                type: Boolean,
                default() {
                    return true;
                }
            },
            allowEmail: {
                type: Boolean,
                default() {
                    return true;
                }
            },
            allowDownload: {
                type: Boolean,
                default() {
                    return true;
                }
            },
        },
        data() {
            return {
                requestInProgress: false,
                isOpen: false,
                isPreparingEmail: false,
            };
        },
        methods: {
            open(action = null, params = {}) {
                document.querySelector('body').style.overflow = 'hidden';
                this.isOpen = true;
                this.$emit('reveal');

                switch (action)
                {
                    case 'print':
                        this.print()
                        break
                    case 'email':
                        this.email(params)
                        break
                    case 'download':
                        this.download()
                        break
                }
            },
            close() {
                this.isOpen = false;
                document.querySelector('body').style.overflow = '';
                this.$emit('hide');
            },
            print() {
                if (this.isImage) {
                    printElement(this.$refs.image)
                    return
                }

                this.$refs.frame.contentWindow.print();
                window.document.activeElement.blur();
            },
            download() {
                window.location = this.baseUri + '/download';
                window.document.activeElement.blur();
            },
            email(params = {}) {
                this.requestInProgress = true;
                this.isPreparingEmail = true
                window.document.activeElement.blur();

                (new Resource).getHttp().post(this.baseUri + '/library').then((response) => {
                    this.$refs.compose.mergeMessageDefaults({
                        to: params.defaultMessageContact ?? null,
                        subject: 'Your ' + this.title,
                        attachments: [response.data]
                    })

                    this.$refs.compose.open()

                    this.requestInProgress = false;
                    this.isPreparingEmail = false
                }, (error) => {
                    alert('The email could not be sent.');
                    this.requestInProgress = false;
                    this.isPreparingEmail = false
                });

            },
        },
        computed: {
            emailDisabled() {
                return this.requestInProgress ? 'disabled' : false;
            },
            containerStyles() {
                if (!this.isOpen) {
                    return 'display: none;';
                }

                return 'position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.8); z-index: 100;';
            },
            isImage() {
                return ['image/jpeg', 'image/jpg', 'image/png'].includes(this.mime)
            }
        }
    }
</script>